import Clocks from '@/components/clock/clock-list';
import ClockCreate from '@/components/clock/clock-create';
import ClockUpdate from '@/components/clock/clock-update';

const routes = [
	{
		path: '/clocks',
		name: 'clocks',
		component: Clocks,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{ text: 'Clocks' }
			],
			requiresAuth: true
		}
	},
	{
		path: '/clocks/create',
		name: 'clockcreate',
		component: ClockCreate,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{
					text: 'Clocks',
					href: 'javascript:history.back()',
				},
				{ text: 'Create' }
			],
			requiresAuth: true
		}
	},
	{
		path: '/clocks/:id/update',
		name: 'clockupdate',
		component: ClockUpdate,
		meta: {
			breadcrumb: [
				{
					text: 'Home',
					to: { name: 'home' }
				},
				{
					text: 'Clocks',
					//to: { name: 'clocks' },
					href: 'javascript:history.back()',
				},
				{ text: 'Edit' }
			],
			requiresAuth: true
		}
	},
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/clock/routes/index.js